import NumericInput from './NumericInput';
import { forwardRef, useImperativeHandle, useState, useRef, useCallback, useEffect } from 'react';
import { useGridCellEditor } from 'ag-grid-react';

const NumericEditor = forwardRef(({ onValueChange, onChange, value, ...otherProps }, ref) => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(isNaN(parseInt(value)) ? '' : value);
  const isEditingCompletedRef = useRef(false);
  
  const parsedValue = () => {
    if (inputValue === '') {
      return '';
    }
    return Number(inputValue);
  };

  useEffect(() => {
    setInputValue(isNaN(parseInt(value)) ? '' : value);
  }, [otherProps.column?.colDef?.field]);

  const isCancelAfterEnd = useCallback(() => {
    if (isEditingCompletedRef.current) return true; // Returning true to avoid setting new value
    isEditingCompletedRef.current = true; // prevent further commits
    onValueChange(parsedValue());
    return false;
  }, [onValueChange, inputValue]);

  const afterGuiAttached = useCallback(() => {
    focusOnInput();
  }, []);

  useGridCellEditor({
    isCancelAfterEnd,
    afterGuiAttached,
  });

  useImperativeHandle(ref, () => ({
    getValue: parsedValue,
    focusOnInput
  }));

  const focusOnInput = () => {
    if (inputRef?.current) {
      inputRef.current?.focus?.();
    }
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    return onChange?.(event);
  };

  return <NumericInput ref={inputRef} onChange={handleChange} value={inputValue} {...otherProps} />;
});

export default NumericEditor;
